// 页面样式
import css from 'css/page/themeDetail.scss'

// 公共方法
import {
  domObserver,
  headerInit,
  memberShip,
} from 'js/common/index'
// 动画
import {
  viewer,
} from 'js/animation/index'

/**
 * 绑定 DOM 事件
 */
function bindEvts() {
  memberFormInit()
}

/**
 * 登录相关表单事件初始化
 */
function memberFormInit() {
  memberShip.closeForm.init()
  memberShip.forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member',
  })
  memberShip.loginFormInit({
    success: () => headerInit(),
    form: '.yui-memberform0-login',
    mask: '.mask-member',
  })
  memberShip.registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member',
  })
}

/**
 * 滑块初始化
 */
function swipersInit() {
  // 顶部 banner
  swiper.init({
    selector: '.swiper0',
    options: {
      pagination: {
        bulletActiveClass: 'selected',
        bulletClass: 'dot',
        clickable: true,
        el: '.swiper-pagination-bullets',
      }
    }
  })
}

/**
 * 查看大图初始化
 */
function viewerInit () {
  let wrappers = document.querySelectorAll('.sec-1 .view')

  if (wrappers) {
    for (let wrapper of wrappers) {
      viewer.init({
        wrapper,
      })

      let obj = wrapper.querySelectorAll('img')
      if (obj.length === 0) {
        utils.log.e(`[screenshotInit] failed to find tags whose selector is 'img'.`)
        continue
      }

      viewer.getImgUrl({
        imgs: Array.from(obj),
      })
    }
  }
}

/**
 * UI 初始化
 */
function uiInit() {
  viewerInit()
}

window._dataBus.get('domReadyObserver').subscribe(() => {
  uiInit()
  bindEvts()
})



// WEBPACK FOOTER //
// ./js/page/themeDetail.js